import React, {useEffect, useState, useMemo} from 'react';
import { connect } from 'react-redux';
// import { Actions as LEAVEACTIONS } from '../../store/actions/leaveActions';
// import { Actions as EMPLOYEEACTIONS } from '../../store/actions/employeeActions';

import NoteRow from './NoteRow';
import {format,addMonths} from 'date-fns'

const Notes = ({
  notes,
  nextToken,
  getMoreNotes

}) => {
  return (
    <div className='px-8 pt-12'>

      {/* consider adding date filters + type filter */}
      {/*<div style={{
          border: "1px solid #bbbcbc",
          borderBottom: 'none',
          position: "relative"
        }}>
        <i className="si si-magnifier"
          style={{
            position: "absolute",
            top: 15,
            left: 15,
          }}
         />
        <input name='search' onChange={e => setSearch(e.target.value)} value={search}
          style={{
            border: "none",
            display: "inline-block",
            maxWidth: "100%",
            width: "100%",
            padding: 10,
            paddingLeft: 40
          }}
         />
      </div>*/}
      <div className="table-responsive">

        <div id="active-people-table_wrapper" className="dataTables_wrapper no-footer">
          <table
            id="active-people-table"
            className="js-table-sections table table-hover"
          >
            <thead style={{ display: 'table-header-group' }}>
              <tr>
                <th>DATE</th>
                <th>NOTE</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {notes ? (
                notes.map((note) => (
                  <NoteRow key={note.id} note={note} />
                ))
              ) : (
                <tr><td colSpan="6"> Loading Notes, hold on...</td></tr>
              )}
              {nextToken &&
                <tr><td colSpan="6">
                  <span onClick={getMoreNotes}>View More Logs</span>
                </td></tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {}
};

const mapDispatchToProps = (dispatch) => ({
});


export default connect(mapStateToProps, mapDispatchToProps)(Notes);
